import { useEffect } from 'react';

export function MetatagComponent({ name, content }: { name: string; content: string }) {
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = name;
    meta.content = content;

    document.head.appendChild(meta);

    return () => {
      document.head.removeChild(meta);
    };
  }, [content]);

  return null;
}
